<div class="vendor" (click)="clickVendor.emit()" [ngClass]="{selected: isSelected}">
	<img class="vendor-logo" [attr.src]="'assets/images/vendors/' + image" [attr.alt]="name" />
</div>
